import { appProfileDaysG4Fr } from './golf4App.fr.js';
// Frans (fr-FR), profileApp: zelfde vorm als profileApp.nl.ts. Gewoontes, nooit nationaliteit;
// "jullie" wordt "ta famille" (geen vous). Geloof respectvol en precies (ablutions, Aïd, casher).
// consent.version blijft gelijk aan nl (PROFILE_CONSENT_VERSION).
export const appProfileFr = {
    title: 'Ce qui convient à notre famille',
    intro: 'Choisis ce qui convient à ta famille. Les listes deviennent plus calmes. Tout est facultatif.',
    privacyLine: 'Seuls les parents peuvent voir et modifier ceci. La famille éloignée associée ne le voit jamais.',
    privacyLink: 'Politique de confidentialité',
    privacyPage: {
        title: 'Politique de confidentialité',
        back: 'Retour à l’appli',
        intro: 'À propos de « Ce qui convient à notre famille » : cuisine, religion, alimentation et jours particuliers. En bref et clairement.',
        sections: [
            {
                title: 'Dans quel but',
                body: 'Nous utilisons les choix de ta famille uniquement pour décider quelles options tu vois : modèles, pictogrammes, recettes et jours particuliers. Pas pour de la publicité, pas pour établir des profils sur ta famille et pas pour les partager.',
            },
            {
                title: 'Quelles données',
                body: 'Cuisines et traditions, religion (avec les pratiques et l’école juridique choisies), règles alimentaires (comme halal ou végétarien), différences par membre de la famille, « mange autre chose » pour une recette et les jours particuliers que tu as activés. La religion, le halal et le casher, et parfois une tradition, sont des données personnelles sensibles (article 9 du RGPD).',
            },
            {
                title: 'Base légale',
                body: 'Ton consentement explicite (article 9, paragraphe 2, point a, du RGPD). Un parent le donne pour lui-même et pour les enfants de moins de 16 ans ; un adulte qui a son propre compte peut donner lui-même son consentement pour sa propre différence. Tout est facultatif : sans consentement, l’appli fonctionne normalement.',
            },
            {
                title: 'Qui le voit',
                body: 'Seuls les parents de ta famille voient les choix eux-mêmes. La tablette et l’appli montrent seulement ce qui convient ; pour les repas, nous indiquons qui ne mange pas quelque chose. La famille éloignée associée, les invités, les liens de partage, les flux d’agenda, les messages d’erreur et les fichiers journaux ne reçoivent jamais ces choix. Les jours particuliers n’apparaissent dans un export d’agenda que si tu l’actives séparément.',
            },
            {
                title: 'Combien de temps',
                body: 'Tant que le consentement est valable. Le retirer efface les choix immédiatement ; ils disparaissent des sauvegardes sous 90 jours. La preuve du consentement lui-même (qui, quand, quel texte, sans le contenu) est conservée jusqu’à 5 ans après le retrait, ou jusqu’à la suppression de la famille.',
            },
            {
                title: 'Tes droits',
                body: 'Tu peux consulter et modifier tes données dans Réglages · Ce qui convient à notre famille, les télécharger dans Réglages · Télécharger les données (chaque parent ses propres données, l’administrateur tout), retirer ton consentement (ce qui efface tout) et demander l’effacement. Si tu n’es pas d’accord avec quelque chose, tu peux porter plainte auprès de l’Autoriteit Persoonsgegevens (l’autorité néerlandaise de protection des données).',
            },
            {
                title: 'Responsable et contact',
                body: 'AMUMIN B.V. est responsable de ces données. Tu télécharges toi-même tes propres données dans Réglages. Pour une question ou un effacement, contacte AMUMIN B.V. ; tant que l’adresse fixe pour la confidentialité manque ci-dessous, passe par l’administrateur du compte de ta famille. Une adresse fixe pour la confidentialité et les données du registre du commerce (KvK) figureront ici avant que d’autres familles puissent s’inscrire.',
            },
        ],
    },
    settingsBody: 'Cuisine, religion, alimentation et jours particuliers',
    saveBar: 'Enregistrer les modifications',
    invite: {
        title: 'Qu’est-ce qui convient à ta famille ?',
        body: 'Choisis cuisine, religion et alimentation, et tu verras surtout ce qui te convient. Ce n’est pas obligatoire.',
        start: 'Configurer',
        later: 'Pas maintenant',
        never: 'Non merci',
    },
    otherParent: {
        title: 'Ce qui convient à ta famille',
        body: '{name} a indiqué ce qui convient à ta famille : {what}. Est-ce que ça te convient aussi ?',
        titleNeutral: 'Ce qui vous convient',
        bodyNeutral: '{name} a indiqué ce qui vous convient : {what}. Est-ce que ça te convient aussi ?',
        view: 'Voir',
    },
    wizard: {
        title: 'Qu’est-ce qui convient à ta famille ?',
        body: 'Choisis seulement ce que tu veux ; le reste peut rester vide. Tu peux tout modifier plus tard.',
        skip: 'Passer',
        skipQuestion: 'Passer cette question',
        next: 'Suivant',
        done: 'Fini',
        save: 'Enregistrer',
        nothingSaved: 'Tu n’as rien choisi, donc nous n’enregistrons rien.',
        step: '{n} sur {total}',
        question: '{step} · question {n} sur {total}',
    },
    traditions: {
        title: 'Cuisine et traditions',
        body: 'Quelles cuisines et traditions font partie de ta famille ? Tu peux en choisir plusieurs.',
        hint: 'Il s’agit d’habitudes, pas de nationalité. Nous retenons seulement les cuisines que ta famille aime. Nous l’utilisons pour l’ordre des recettes et pour proposer des jours de fête.',
        labels: {
            dutch: 'Néerlandaise',
            turkish: 'Turque',
            moroccan: 'Marocaine',
            surinamese: 'Surinamienne',
            antillean: 'Antillaise',
            indonesian: 'Indo-néerlandaise / Indonésienne',
            moluccan: 'Moluquoise',
            italian: 'Italienne',
            polish: 'Polonaise',
            middle_eastern: 'Du Moyen-Orient',
            other: 'Autre',
        },
        otherKitchens: {
            title: 'Quelles cuisines ta famille aime-t-elle ?',
            more: 'Plus de cuisines',
        },
    },
    suggestion: {
        title: 'Est-ce que ça convient à ta famille ?',
        body: 'C’est toi qui choisis. Tu peux toujours modifier.',
        accept: 'Oui, reprendre',
        decline: 'Choisir moi-même',
        days: 'Il y a aussi {sets} à ajouter. Tu les actives toi-même dans Jours particuliers.',
    },
    faiths: {
        title: 'Religion',
        body: 'Tu verras alors les options qui vont avec. Tu pourras ensuite activer toi-même les jours de fête.',
        none: 'Aucune religion',
        shows: 'Tu verras alors {list}',
        /** Golf 6b: gewoontes bij het gekozen geloof, optioneel (niets voorgevinkt). */
        madhab: {
            title: 'Quelle école juridique (madhhab) suivez-vous ?',
            body: 'Cela nous permet notamment de bien régler l’heure de l’asr. Vous pouvez toujours le modifier.',
            hint: 'Les mosquées turques, comme celles de Diyanet et de Milli Görüş, suivent l’école hanafite. Les mosquées marocaines suivent le plus souvent l’école malikite.',
            unknown: 'Je ne sais pas / passer',
            labels: { hanafi: 'Hanafite', shafii: 'Chaféite', maliki: 'Malikite', hanbali: 'Hanbalite' },
        },
        practicesTitle: 'Qu’est-ce qui fait partie de votre vie ?',
        practicesHint: 'Coche ce que vous faites. Seul cela sera proposé comme rendez-vous, tâche ou pictogramme. Ne rien cocher, c’est possible aussi.',
        openHint: 'Si tu ne choisis rien, Prier et Cours à la mosquée ne font pas partie des propositions (la recherche les trouve quand même). Choisis la religion de ta famille si tu veux les voir.',
        labels: {
            islam: 'Islam',
            christianity: 'Christianisme',
            judaism: 'Judaïsme',
            hinduism: 'Hindouisme',
            other: 'Une autre religion',
        },
    },
    food: {
        title: 'Alimentation',
        body: 'Les recettes et les courses qui ne conviennent pas sont mises de côté. Tu les retrouves toujours avec la recherche ou « Tout afficher ».',
        labels: {
            halal: 'Halal',
            no_pork: 'Sans porc',
            no_beef: 'Sans bœuf',
            vegetarian: 'Végétarien',
            vegan: 'Végan',
            kosher: 'Casher',
            no_alcohol: 'Sans alcool',
        },
    },
    days: {
        ...appProfileDaysG4Fr,
        title: 'Jours particuliers dans l’agenda',
        optional: 'facultatif',
        body: 'Tu veux des jours en plus dans l’agenda ? Les jours fériés néerlandais sont activés ; les autres ensembles sont tous désactivés. Active ce que tu veux voir.',
        perDay: 'Choisir jour par jour',
        more: 'Plus de jours particuliers',
        next: 'Prochaine date : {dates}',
        noDates: 'Les dates de cette année arrivent bientôt.',
        expected: '(prévu)',
        expectedNote: 'Le jour exact peut changer d’un jour.',
        expectedTag: 'prévu',
        sheet: {
            expected: 'Ce jour n’est pas encore fixé.',
            when: 'Tombe le {dates}.',
            confirm: 'Confirmer le jour',
            confirmHint: 'Confirme-le ou déplace-le dans Ce qui convient à notre famille, Jours particuliers.',
        },
        eveBefore: 'Commence la veille au coucher du soleil.',
        eitherOr: '{a} ou {b}',
        nl: {
            title: 'Jours fériés néerlandais',
            note: 'Pour tout le monde. Activé par défaut.',
            days: {
                nieuwjaarsdag: 'Jour de l’An',
                goede_vrijdag: 'Vendredi saint',
                pasen: 'Pâques',
                koningsdag: 'Fête du Roi',
                bevrijdingsdag: 'Jour de la Libération',
                hemelvaartsdag: 'Ascension',
                pinksteren: 'Pentecôte',
                kerstmis: 'Noël',
                moederdag: 'Fête des mères',
                vaderdag: 'Fête des pères',
                sinterklaas: 'Saint-Nicolas',
                oudejaarsavond: 'Saint-Sylvestre',
            },
        },
        dayNames: {
            ramadan_start: 'Début du Ramadan',
            ramadan_end: 'Dernier jour du Ramadan',
            eid_al_fitr: 'Aïd el-Fitr (fête de fin du Ramadan)',
            eid_al_adha: 'Aïd el-Adha (fête du Sacrifice)',
            islamic_new_year: 'Nouvel An islamique',
            mawlid: 'Mawlid (Mevlid)',
        },
        tradition: {
            title: 'Quel calendrier suit ta famille ?',
            body: 'Les mosquées ne fixent pas toutes les jours de fête de la même manière.',
            options: {
                diyanet: 'Turquie (Diyanet, calendrier fixe)',
                saudi: 'Arabie saoudite (observation de la lune)',
                morocco: 'Maroc (observation de la lune, confirmation la veille)',
                own_mosque: 'Ma mosquée (± 1 jour)',
            },
            hints: {
                diyanet: 'Les dates sont fixées des années à l’avance.',
                saudi: 'Jusqu’à l’annonce la veille, tu vois deux jours possibles.',
                morocco: 'Tombe souvent un jour plus tard qu’en Arabie saoudite. Jusqu’à l’annonce, tu vois deux jours possibles.',
                own_mosque: 'Tu vois le calendrier fixe. Si ta mosquée choisit un jour plus tôt ou plus tard, corrige-le ici.',
            },
            defaultNote: 'Par défaut, le calendrier fixe de Diyanet. Choisis ce que suit ta mosquée.',
            confirmTitle: 'Déjà connu ?',
            confirmBody: 'Touche le jour choisi par ta mosquée. Il sera alors fixé dans l’agenda.',
            unknown: 'Pas encore connu',
            confirmedNote: 'Fixé dans l’agenda.',
        },
        sets: {
            tr_national: 'Jours fériés turcs',
            keti_koti: 'Keti Koti',
            indies_remembrance: 'Commémoration du 15 août',
            id_independence: 'Fête de l’indépendance de l’Indonésie',
            it_national: 'Jours fériés italiens',
            pl_national: 'Jours fériés polonais',
            islamic: 'Fêtes islamiques',
            christian: 'Fêtes chrétiennes',
            jewish: 'Fêtes juives',
            hindu: 'Fêtes hindoues',
        },
        ics: {
            toggle: 'Jours particuliers aussi dans les exports d’agenda',
            warning: 'Ton appli d’agenda (par exemple Google) verra alors ces jours.',
        },
    },
    flags: {
        pork: 'porc',
        beef: 'bœuf',
        meat: 'viande',
        fish: 'poisson',
        shellfish: 'crustacés et coquillages',
        dairy: 'produits laitiers',
        egg: 'œuf',
        honey: 'miel',
        gelatin: 'gélatine',
        alcohol: 'alcool',
    },
    kitchens: {
        dutch: 'Hollandaise',
        turkish: 'Turque',
        moroccan: 'Marocaine',
        surinamese: 'Surinamienne',
        antillean: 'Antillaise',
        indonesian: 'Indo-néerlandaise',
        moluccan: 'Moluquoise',
        italian: 'Italienne',
        polish: 'Polonaise',
        middle_eastern: 'Du Moyen-Orient',
        chinese: 'Chinoise',
        indian: 'Indienne',
        mexican: 'Mexicaine',
        greek: 'Grecque',
        west_african: 'D’Afrique de l’Ouest',
        central_african: 'D’Afrique centrale',
        east_african: 'D’Afrique de l’Est',
        american: 'Américaine',
    },
    member: {
        follows: 'Suit la famille',
        differs: 'Différent de la famille',
        reset: 'Suivre à nouveau la famille',
        plus: 'Suit la famille, plus {what}',
        minus: 'Suit la famille, sans {what}',
        faithDiffers: 'Religion : {what}',
        notPossible: 'Pour {name}, tu ne peux pas régler ceci à part. C’est possible seulement si {name} donne son consentement avec son propre compte. En attendant, {name} suit la famille.',
        askSelf: 'Demande à {name} de le régler lui-même.',
        shareLink: 'Partager le lien',
    },
    consent: {
        version: '2026-09-25.4',
        title: 'D’accord ?',
        text: 'La religion, les règles alimentaires et les cuisines peuvent être des données sensibles. Nous les utilisons uniquement pour choisir les options que tu vois.\nSeuls les parents peuvent voir et modifier ceci. La tablette et l’appli montrent ce qui convient ; pour les repas, nous indiquons qui ne mange pas quelque chose.\nCertains choix permettent d’ajouter des éléments au tableau. Toutes les personnes présentes dans la pièce les voient alors.\nNous ne partageons rien avec la famille éloignée associée ni dans les listes partagées. Les jours particuliers n’apparaissent dans l’agenda ou dans un export d’agenda que si tu l’actives toi-même.\nTu peux retirer ton consentement à tout moment, ce qui efface tout immédiatement. Tout disparaît des sauvegardes sous 90 jours.\nAMUMIN B.V. est responsable de ces données. Tes droits figurent dans la politique de confidentialité.',
        check: 'Je donne mon consentement pour moi-même et pour mes enfants de moins de 16 ans.',
        given: 'Consentement donné par {name} le {date}',
        /** Fijnslijpen: zonder bekende naam (geen "door  op"). */
        givenAt: 'Consentement donné le {date}',
        renew: 'L’explication a changé. Lis-la et donne à nouveau ton consentement.',
        withdraw: 'Retirer le consentement et effacer',
        withdrawConfirm: 'Nous effaçons les cuisines, la religion, les règles alimentaires et les jours particuliers de ta famille. Tu verras ensuite de nouveau tout. Continuer ?',
        withdrawn: 'Effacé. Tu vois de nouveau tout.',
    },
    selfConsent: {
        title: 'Est-ce juste pour toi ?',
        text: 'Tu indiques pour toi-même ta religion ou ce que tu manges. Nous l’utilisons uniquement pour choisir les options que tu vois, et pour les repas, nous citons ton prénom si quelque chose ne te convient pas. Seuls toi et les parents de cette famille le voient. Le retirer l’efface immédiatement.',
        check: 'Je donne mon consentement pour moi-même.',
        withdraw: 'Retirer mon consentement',
    },
    daySetsInline: {
        tr_national: 'des jours fériés turcs',
        keti_koti: 'Keti Koti',
        indies_remembrance: 'la commémoration du 15 août',
        id_independence: 'la fête de l’indépendance de l’Indonésie',
        it_national: 'des jours fériés italiens',
        pl_national: 'des jours fériés polonais',
        islamic: 'des fêtes islamiques',
        christian: 'des fêtes chrétiennes',
        jewish: 'des fêtes juives',
        hindu: 'des fêtes hindoues',
    },
    hidden: {
        showAll: 'Tout afficher',
        showLess: 'Afficher moins',
        count: { one: '{count} option masquée', other: '{count} options masquées' },
        groupFood: 'Masqué, car ta famille {rules}',
        groupFaith: 'Fait partie d’une autre religion',
        groupNotChosen: 'Apparaît si tu choisis « {what} »',
        groupFaithOpen: 'Masqué tant que ta famille n’a pas choisi de religion',
        /** Golf 6b: geloof gekozen, gewoonte niet aangevinkt. */
        groupPractice: 'Pas coché dans la religion',
        practice: 'Masqué, car ta famille n’a pas coché {practice} dans la religion. Modifie-le dans les Réglages.',
        change: 'Modifier',
        faith: 'Fait partie de : {faiths}. Ta famille a choisi autre chose.',
        faithNone: 'Masqué, car ta famille a choisi « Aucune religion ». Tu peux le modifier dans Réglages.',
        notChosen: 'Apparaît si tu choisis « {what} » dans Réglages.',
        faithOpen: 'Masqué tant que ta famille n’a pas choisi de religion. Tu peux le modifier dans Réglages.',
        food: 'Masqué, car ta famille {rules}. Tu peux le modifier dans Réglages.',
        variant: 'Une variante de cette recette figure déjà dans la liste.',
        rulePhrase: {
            halal: 'mange halal',
            no_pork: 'ne mange pas de porc',
            no_beef: 'ne mange pas de bœuf',
            vegetarian: 'mange végétarien',
            vegan: 'mange végan',
            kosher: 'mange casher',
            no_alcohol: 'ne boit pas d’alcool',
        },
    },
    warning: {
        contains: 'Contient : {ingredient}.',
        containsMany: 'Contient : {ingredient}.',
        person: {
            halal: '{names} mange halal.',
            no_pork: '{names} ne mange pas de porc.',
            no_beef: '{names} ne mange pas de bœuf.',
            vegetarian: '{names} mange végétarien.',
            vegan: '{names} mange végan.',
            kosher: '{names} mange casher.',
            no_alcohol: '{names} ne boit pas d’alcool.',
        },
        people: {
            halal: '{names} mangent halal.',
            no_pork: '{names} ne mangent pas de porc.',
            no_beef: '{names} ne mangent pas de bœuf.',
            vegetarian: '{names} mangent végétarien.',
            vegan: '{names} mangent végan.',
            kosher: '{names} mangent casher.',
            no_alcohol: '{names} ne boivent pas d’alcool.',
        },
        everyone: {
            halal: 'Toute la famille mange halal.',
            no_pork: 'Personne à table ne mange de porc.',
            no_beef: 'Personne à table ne mange de bœuf.',
            vegetarian: 'Toute la famille mange végétarien.',
            vegan: 'Toute la famille mange végan.',
            kosher: 'Toute la famille mange casher.',
            no_alcohol: 'Personne à table ne boit d’alcool.',
        },
        check: 'Attention, peut contenir : {what}.',
        meatDairy: 'Viande et produits laitiers ensemble : {meat} et {dairy}.',
        item: {
            pork: 'Contient du porc.',
            beef: 'Contient du bœuf.',
            meat: 'Contient de la viande.',
            fish: 'Contient du poisson.',
            shellfish: 'Contient des crustacés ou des coquillages.',
            dairy: 'Contient des produits laitiers.',
            egg: 'Contient de l’œuf.',
            honey: 'Contient du miel.',
            gelatin: 'Contient généralement de la gélatine de porc.',
            alcohol: 'Contient de l’alcool.',
        },
        swap: 'Astuce : {swap} au lieu de {ingredient}.',
        swapButton: 'Remplacer',
        addAnyway: 'Laisser tel quel',
        add: 'OK',
        eatsOther: '{name} mange autre chose',
        whoEats: 'Qui est à table ?',
        everyoneEats: 'Tout le monde',
        and: 'et',
    },
    screens: {
        practices: {
            prayer: 'Prier',
            wudu: 'Ablutions',
            mosque: 'Mosquée (cours)',
            quran: 'Cours de Coran',
            church: 'Église',
            shabbat: 'Chabbat',
            synagogue: 'Synagogue',
            mandir: 'Mandir',
        },
        noneHint: 'Nous mettons alors de côté les options religieuses comme Prier et Cours à la mosquée.',
        otherFaithHint: 'Prier reste visible ; les options des religions citées, non.',
        stepLabel: 'Étape {n} sur {total}',
        progress: 'Question {n} sur {total}',
        noConsentYet: 'Sans consentement, nous n’enregistrons rien.',
        saved: 'Enregistré. Tu vois surtout ce qui convient à ta famille.',
        savedMember: 'Enregistré pour {name}.',
        resetMember: '{name} suit de nouveau la famille.',
        savedSelf: 'Enregistré.',
        resetSelf: 'Tu suis de nouveau la famille.',
        selfWithdrawn: 'Tes propres choix sont effacés.',
        noChanges: 'Rien n’a changé.',
        loadError: 'Impossible de charger ceci.',
        changed: 'Tu as modifié quelque chose.',
        settingsCardBody: 'Cuisine, religion, alimentation et jours particuliers',
        membersTitle: 'Par membre de la famille',
        membersIntro: 'La famille sert de référence. Un membre peut faire autrement.',
        consentTitle: 'Consentement',
        appliesTo: 'S’applique à : {list}',
        selfTag: '{name} (soi-même)',
        kidsTag: '{list} (enfants de moins de 16 ans)',
        noConsent: 'Aucun consentement n’a encore été donné. Nous le demandons au premier enregistrement.',
        inviteLater: 'Nous te le redemanderons plus tard.',
        inviteNever: 'Très bien. Tu le retrouves toujours dans Réglages.',
        otherParentWhat: 'cuisine, religion et alimentation',
        dayCount: 'jour {n} sur {total}',
        daysOn: 'Activé',
        daysOff: 'Désactivé',
        lessDays: 'Moins de jours particuliers',
        offeredEmpty: 'Choisis plus haut une cuisine ou une religion, et nous proposerons des jours adaptés.',
        member: {
            title: 'Adapter',
            open: 'Adapter pour {name}',
            faith: 'Religion',
            food: 'Alimentation',
            foodHint: 'Les choix de la famille sont cochés. Ce que tu actives s’ajoute, ce que tu désactives ne s’applique pas à {name}. Les futurs choix de la famille suivent automatiquement.',
            faithFollows: 'Religion : comme la famille',
            lapsed: '{name} règle maintenant ceci lui-même.',
            selfIntro: 'Tu règles ceci pour toi-même.',
            selfGiven: 'Tu as donné ton consentement pour toi-même.',
            withdrawSelfTitle: 'Effacer ton propre choix ?',
            withdrawSelfBody: 'Tu suis alors de nouveau la famille. Ce que tu as réglé pour toi-même est effacé immédiatement.',
            withdrawSelfConfirm: 'Effacer',
            save: 'Enregistrer',
            linkCopied: 'Lien copié.',
            notSetYet: 'Indique d’abord ce qui convient à la famille et enregistre. Ensuite, tu peux faire autrement pour chaque membre.',
        },
        self: {
            title: 'Ce qui me convient',
            intro: 'Ta religion ou ce que tu manges est différent de ta famille ? Tu le règles ici toi-même. Seuls toi et tes parents le voient.',
            parents: 'Ce sont tes parents qui règlent ceci. À partir de 16 ans, tu peux indiquer ici toi-même ce qui est différent pour toi.',
            notYet: 'Tes parents n’ont pas encore indiqué ce qui convient à ta famille. Ensuite, tu pourras faire tes propres choix ici.',
            settingsBody: 'Ta propre religion et ton alimentation',
        },
    },
};
//# sourceMappingURL=profileApp.fr.js.map